import { Trans } from "react-i18next";
import { PublishedEmptyState, type PublishedEmptyStateProps } from "./PublishedEmptyState";

export const ScheduledEmptyState = (props: Omit<PublishedEmptyStateProps, "title">) => (
  <PublishedEmptyState {...props} title={<Trans>No Scheduled Posts Yet</Trans>} />
);
